import { Component, Input } from '@angular/core';
import { parseStrDefaultToZero } from '@sharedUtils';

import { TotalBreadcrumbContent } from '../../services/content/content-jsons/total-breadcrumb.content';

@Component({
  selector: 'app-total-breadcrumb',
  templateUrl: './total-breadcrumb.component.html',
  styleUrls: ['./total-breadcrumb.component.scss'],
  standalone: true,
})
export class TotalBreadcrumbComponent {
  content = TotalBreadcrumbContent;

  @Input() prefix: string;
  @Input() amount: string;
  @Input() showAsterisk: boolean = true;

  buildDisplay() {
    if (this.prefix) {
      if (parseStrDefaultToZero(this.amount)) {
        return this.prefix + this.amount + (this.showAsterisk ? `*` : ``);
      } else {
        return this.prefix;
      }
    } else {
      if (parseStrDefaultToZero(this.amount)) {
        return this.content.giftingAmount + this.amount + (this.showAsterisk ? `*` : ``);
      } else {
        return '';
      }
    }
  }
}
